// extracted by mini-css-extract-plugin
export default {"cta":"IG-z","disabled":"JG-z"};